export interface ICookies {
  [key: string]: string,
}

interface IRequest {
  cookies: ICookies,
}

class ClientCookie {
  constructor(private _cookie: ICookies) {}

  public static fromRequest(request: IRequest): ClientCookie {
    return new ClientCookie(request.cookies);
  }

  public static async fromNextHeader(): Promise<ClientCookie> {
    // eslint-disable-next-line global-require
    const { cookies } = require('next/headers');
    const cookieStore = await cookies();

    const cookiesData: ICookies = {};

    cookieStore.getAll().forEach((cookie: { name: string, value: string }) => {
      cookiesData[cookie.name] = cookie.value;
    });

    return new ClientCookie(cookiesData);
  }

  get cookie() {
    return this._cookie;
  }
}

export default ClientCookie;
